import { createStore } from "redux";
import { seasons } from "./reducers/seasons";

export default createStore(seasons);